<template>
<div class="swaychat-row" v-if="images.length || files.length">
  <div class="swaychat-card-message  swaychat-bounceIn">
    <div class="swaychat-card-message-content">
      <ul class="swaychat-card-gallery" v-if="images.length">
        <li v-for="item in images" v-if="item.url">
          <div class="swaychat-loading-circle"></div>
          <a :href="makeAliasHost(item.url)" @click.prevent="seePreview(item.url)">
            <image-component :src="makeAliasHost(item.url)+'-/scale_crop/240x240/center/'"></image-component>
          </a>
        </li>
      </ul>
      <ul class="swaychat-card-list" v-if="files.length">
        <li v-for="item in files">
          <a :href="makeAliasHost(item.url)" target="_blank">
            <div class="swaychat-card-message-fileinfo">
              <span class="swaychat-card-message-filename">{{ item.name }}</span>
              <span class="swaychat-card-message-filesize">{{ convertFilesize(item.size) }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="swaychat-card-message-footer">
      <h6>
        {{ getLang.sent }} {{ sent }}
      </h6>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import moment from 'moment'
import ImageComponent from '../media/ImageComponent.vue'

export default {
  components: {
    ImageComponent
  },
  props: [
    'meta',
    'created_at',
    'operator',
    'msgKey',
    'from',
    'read'
  ],
  computed: {
    files() {

      let f = []
      let meta = this.meta

      for (let i = 0; i < meta.length; i++) {
        if (meta[i].format_type != 'image' && meta[i].upload == 100 && !meta[i].abort) {
          f.push(meta[i])
        }
      }

      return f
    },
    images() {

      let f = []
      let meta = this.meta

      for (let i = 0; i < meta.length; i++) {
        if (meta[i].format_type == 'image' && meta[i].upload == 100 && !meta[i].abort) {
          f.push(meta[i])
        }
      }

      return f

    },
    sent() {
      return moment(this.created_at).fromNow()
    },
    ...mapGetters([
      'getLang'
    ])
  },
  methods: {
    convertFilesize(bytesize) {
      let size = bytesize * 0.001

      if (size >= 1000)
        return (size / 1000).toFixed(1) + ' MB'

      if (size.toFixed(1) <= 0)
        return '0 KB'

      return size.toFixed(1) + ' KB'
    },
    seePreview(url) {
      this.$store.commit('setPreviewImg', url)
    },
    makeAliasHost (url) {
      const host = '@@UPLOADCARE_ALIAS_HOST';

      return url && url.indexOf('www.ucarecdn.com') !== -1 && host
        ? url.replace('www.ucarecdn.com', host)
        : url;
    }
  }

}
</script>
